interface TranslatableTextValue {
    ro: string;
    en: string;
    it: string;
    de: string;
    fr: string;
    es: string;
    hu: string;
}

const TranslatableText = {
    CONTACT: {
        ro: "Contact",
        en: "Contact",
        it: "Contatto",
        de: "Kontakt",
        fr: "Contact",
        es: "Contacto",
        hu: "Kapcsolat"
    },
    PHONE_NUMBERS: {
        ro: "Numere de telefon",
        en: "Phone numbers",
        it: "Numeri di telefono",
        de: "Telefonnummern",
        fr: "Numéros de téléphone",
        es: "Números de teléfono",
        hu: "Telefonszámok"
    },
    WE_ARE_HERE_TO: {
        ro: `Suntem aici pentru a vă ajuta să vă planificați următoarea călătorie.
                Contactați-ne pentru informații, oferte personalizate sau rezervări.
                Echipa noastră vă stă la dispoziție oricând!`,
        en: `We are here to help you plan your next trip.
                Contact us for information, personalized offers, or bookings.
                Our team is always at your service!`,
        it: `Siamo qui per aiutarti a pianificare il tuo prossimo viaggio.
                Contattaci per informazioni, offerte personalizzate o prenotazioni.
                Il nostro team è sempre a tua disposizione!`,
        de: `Wir sind hier, um Ihnen bei der Planung Ihrer nächsten Reise zu helfen.
                Kontaktieren Sie uns für Informationen, personalisierte Angebote oder Buchungen.
                Unser Team steht Ihnen jederzeit zur Verfügung!`,
        fr: `Nous sommes là pour vous aider à planifier votre prochain voyage.
                Contactez-nous pour des informations, des offres personnalisées ou des réservations.
                Notre équipe est à votre disposition à tout moment !`,
        es: `Estamos aquí para ayudarte a planificar tu próximo viaje.
                Contáctanos para información, ofertas personalizadas o reservas.
                ¡Nuestro equipo está siempre a tu disposición!`,
        hu: `Azért vagyunk itt, hogy segítsünk megtervezni a következő utazását.
                Vegye fel velünk a kapcsolatot információkért, személyre szabott ajánlatokért vagy foglalásokért.
                Csapatunk bármikor az Ön rendelkezésére áll!`
    },
    SERVICES: {
        ro: "Servicii",
        en: "Services",
        it: "Servizi",
        de: "Dienstleistungen",
        fr: "Services",
        es: "Servicios",
        hu: "Szolgáltatások"
    },
    ABOUT_US: {
        ro: "Despre noi",
        en: "About us",
        it: "Chi siamo",
        de: "Über uns",
        fr: "À propos de nous",
        es: "Sobre nosotros",
        hu: "Rólunk"
    },
    ATLAS_TRAVEL_IS: {
        ro: `Atlas Travel Brașov este un partener de încredere pentru organizarea de călătorii și excursii cu autocarul 
    în țară și străinătate. Oferim o gamă diversificată de sejururi și circuituri, atent structurate pentru a 
    satisface preferințele diferitelor categorii de călători, de la familii și grupuri de prieteni la colectivități 
    corporative. Experiența noastră și flota modernă de autocare garantează călătorii confortabile și memorabile în 
    cele mai populare destinații turistice.`,
        en: `Atlas Travel Brașov is a trusted partner in organizing coach trips and excursions 
    both domestically and abroad. We offer a diverse range of stays and tours, carefully designed to 
    meet the preferences of various types of travelers, from families and groups of friends to 
    corporate groups. Our experience and modern coach fleet guarantee comfortable and memorable journeys 
    to the most popular tourist destinations.`,
        it: `Atlas Travel Brașov è un partner affidabile nell’organizzazione di viaggi ed escursioni in pullman 
    in Romania e all’estero. Offriamo un’ampia gamma di soggiorni e circuiti, accuratamente strutturati per 
    soddisfare le preferenze di diverse categorie di viaggiatori, dalle famiglie e gruppi di amici ai 
    gruppi aziendali. La nostra esperienza e la moderna flotta di pullman garantiscono viaggi confortevoli 
    e memorabili verso le destinazioni turistiche più apprezzate.`,
        de: `Atlas Travel Brașov ist ein zuverlässiger Partner für die Organisation von Busreisen und Ausflügen 
    im In- und Ausland. Wir bieten eine vielfältige Auswahl an Aufenthalten und Rundreisen, sorgfältig 
    zusammengestellt, um den Vorlieben verschiedener Reisender gerecht zu werden – von Familien und 
    Freundesgruppen bis hin zu Firmenkunden. Unsere Erfahrung und moderne Busflotte garantieren komfortable 
    und unvergessliche Reisen zu den beliebtesten Reisezielen.`,
        fr: `Atlas Travel Brașov est un partenaire de confiance pour l’organisation de voyages et d’excursions en autocar 
    en Roumanie et à l’étranger. Nous proposons une large gamme de séjours et de circuits, soigneusement 
    conçus pour répondre aux préférences de différents types de voyageurs, des familles et groupes d’amis 
    aux groupes d’entreprises. Notre expérience et notre flotte moderne d’autocars garantissent des voyages 
    confortables et mémorables vers les destinations touristiques les plus populaires.`,
        es: `Atlas Travel Brașov es un socio de confianza para la organización de viajes y excursiones en autobús 
    a nivel nacional e internacional. Ofrecemos una amplia gama de estancias y circuitos, cuidadosamente 
    diseñados para satisfacer las preferencias de distintos tipos de viajeros, desde familias y grupos de 
    amigos hasta colectivos corporativos. Nuestra experiencia y moderna flota de autobuses garantizan viajes 
    cómodos y memorables a los destinos turísticos más populares.`,
        hu: `Az Atlas Travel Brașov megbízható partner az autóbuszos utazások és kirándulások szervezésében 
    belföldön és külföldön egyaránt. Széles választékban kínálunk utazásokat és körutakat, gondosan kialakítva 
    a különböző utazói igényekhez, a családoktól és baráti társaságoktól a vállalati csoportokig. Tapasztalatunk 
    és modern autóbusz-flottánk kényelmes és emlékezetes utazásokat garantál a legnépszerűbb turisztikai 
    célpontokra.`
    },
    OUR_MISSION_IS: {
        ro: `Misiunea noastră este de a transforma dorința de explorare în realitate, asumându-ne toate detaliile 
    logistice pentru a oferi clienților o vacanță fără griji. Echipa noastră de specialiști este dedicată în 
    proporție egală atât asigurării unor servicii de înaltă calitate, cât și creării de experiențe autentice și 
    pline de valoare pentru fiecare participant.`,
        en: `Our mission is to turn the desire for exploration into reality by handling all logistical details 
    and offering our clients a worry-free vacation. Our team of specialists is equally dedicated to 
    providing high-quality services and creating authentic, valuable experiences for every participant.`,
        it: `La nostra missione è trasformare il desiderio di esplorazione in realtà, occupandoci di tutti i dettagli 
    logistici per offrire ai clienti una vacanza senza pensieri. Il nostro team di specialisti è 
    ugualmente dedicato a garantire servizi di alta qualità e a creare esperienze autentiche e di valore 
    per ogni partecipante.`,
        de: `Unsere Mission ist es, den Wunsch nach Entdeckungen Wirklichkeit werden zu lassen, indem wir alle 
    logistischen Details übernehmen und unseren Kunden einen sorgenfreien Urlaub bieten. Unser 
    Spezialistenteam widmet sich gleichermaßen der Bereitstellung hochwertiger Dienstleistungen und der 
    Schaffung authentischer und wertvoller Erlebnisse für jeden Teilnehmer.`,
        fr: `Notre mission est de transformer le désir d’exploration en réalité en prenant en charge tous les 
    détails logistiques afin d’offrir à nos clients des vacances sans souci. Notre équipe de spécialistes 
    s’engage autant à fournir des services de haute qualité qu’à créer des expériences authentiques et 
    riches de sens pour chaque participant.`,
        es: `Nuestra misión es convertir el deseo de explorar en realidad, asumiendo todos los detalles logísticos 
    para ofrecer a nuestros clientes unas vacaciones sin preocupaciones. Nuestro equipo de especialistas 
    está igualmente comprometido con la prestación de servicios de alta calidad y la creación de 
    experiencias auténticas y valiosas para cada participante.`,
        hu: `Küldetésünk, hogy a felfedezés iránti vágyat valóra váltsuk, átvállalva minden logisztikai részletet, 
    és gondtalan nyaralást biztosítsunk ügyfeleink számára. Szakértő csapatunk egyaránt elkötelezett a magas 
    színvonalú szolgáltatások nyújtása és az autentikus, értékes élmények megteremtése iránt minden résztvevő számára.`
    },
    LOOKING_IN_THE_FUTURE: {
        ro: `Privind cu încredere spre viitor, ne extindem constant orizonturile pentru a deveni un operator
            turistic complet. În acest sens, lucrăm la dezvoltarea ofertei noastre cu pachete de călătorii care să
            includă și transportul aerian, pentru a putea descoperi împreună destinații mai îndepărtate și a oferi
            clienților o varietate și o flexibilitate sporită.`,
        en: `Looking confidently toward the future, we are constantly expanding our horizons to become a complete 
            tour operator. To this end, we are developing our offers with travel packages that also include air 
            transport, allowing us to discover more distant destinations together and provide our clients with 
            greater variety and flexibility.`,
        it: `Guardando con fiducia al futuro, ampliamo costantemente i nostri orizzonti per diventare un operatore 
            turistico completo. In questo senso, stiamo sviluppando la nostra offerta con pacchetti di viaggio 
            che includano anche il trasporto aereo, per poter scoprire insieme destinazioni più lontane e offrire 
            ai clienti maggiore varietà e flessibilità.`,
        de: `Mit Zuversicht blicken wir in die Zukunft und erweitern kontinuierlich unseren Horizont, um ein 
            vollständiger Reiseveranstalter zu werden. In diesem Zusammenhang entwickeln wir unser Angebot mit 
            Reisepaketen, die auch Flugreisen beinhalten, um gemeinsam weiter entfernte Ziele zu entdecken und 
            unseren Kunden mehr Vielfalt und Flexibilität zu bieten.`,
        fr: `Tournés avec confiance vers l’avenir, nous élargissons constamment nos horizons afin de devenir un 
            opérateur touristique complet. Dans ce but, nous développons notre offre avec des forfaits de voyage 
            incluant également le transport aérien, pour découvrir ensemble des destinations plus lointaines et 
            offrir à nos clients davantage de variété et de flexibilité.`,
        es: `Mirando al futuro con confianza, ampliamos constantemente nuestros horizontes para convertirnos en un 
            operador turístico integral. En este sentido, estamos desarrollando nuestra oferta con paquetes de 
            viaje que incluyen también transporte aéreo, para descubrir juntos destinos más lejanos y ofrecer a 
            nuestros clientes mayor variedad y flexibilidad.`,
        hu: `Bizakodva tekintünk a jövőbe, és folyamatosan bővítjük látókörünket annak érdekében, hogy teljes körű 
            utazásszervezővé váljunk. Ennek részeként olyan utazási csomagokat fejlesztünk, amelyek légi közlekedést 
            is tartalmaznak, így együtt fedezhetünk fel távolabbi úti célokat, és nagyobb választékot valamint 
            rugalmasságot kínálhatunk ügyfeleinknek.`
    },
    TRIPS_COUNTRY: {
        ro: "Excursii în țară",
        en: "Domestic trips",
        it: "Escursioni nazionali",
        de: "Inlandsreisen",
        fr: "Excursions nationales",
        es: "Excursiones nacionales",
        hu: "Belföldi kirándulások"
    },
    TRIPS_COUNTRY_DESCRIPTION: {
        ro: `Vă propunem călătorii captivante prin cele mai frumoase destinații din România, de la misterul
            castelelor transilvănene și liniștea mănăstirilor vechi, până la splendoarea naturală a Munților
            Carpați și animația stațiunilor de pe litoral. Organizăm excursii tematice și circuituri adaptate
            pentru grupuri de adulți, familii sau elevi, asigurând transport confortabil, cazare atent selectată
            și un program echilibrat care combină cultura, istoria și recreerea.`,
        en: `We offer captivating journeys through Romania’s most beautiful destinations, from the mystery of 
            Transylvanian castles and the tranquility of ancient monasteries to the natural splendor of the 
            Carpathian Mountains and the lively seaside resorts. We organize themed trips and tours tailored 
            for adult groups, families, or students, ensuring comfortable transport, carefully selected 
            accommodation, and a balanced program combining culture, history, and recreation.`,
        it: `Proponiamo viaggi affascinanti attraverso le più belle destinazioni della Romania, dal mistero dei 
            castelli della Transilvania e la tranquillità degli antichi monasteri, allo splendore naturale dei 
            Monti Carpazi e all’energia delle località balneari. Organizziamo escursioni tematiche e circuiti 
            adatti a gruppi di adulti, famiglie o studenti, garantendo trasporti confortevoli, alloggi selezionati 
            con cura e un programma equilibrato che unisce cultura, storia e svago.`,
        de: `Wir bieten faszinierende Reisen durch die schönsten Ziele Rumäniens an – vom Geheimnis der 
            transsilvanischen Schlösser und der Ruhe alter Klöster bis hin zur natürlichen Pracht der Karpaten 
            und dem lebendigen Treiben der Badeorte. Wir organisieren thematische Ausflüge und Rundreisen für 
            Erwachsenengruppen, Familien oder Schüler und sorgen für komfortablen Transport, sorgfältig 
            ausgewählte Unterkünfte und ein ausgewogenes Programm aus Kultur, Geschichte und Erholung.`,
        fr: `Nous vous proposons des voyages captivants à travers les plus belles destinations de Roumanie, du 
            mystère des châteaux de Transylvanie et du calme des anciens monastères à la splendeur naturelle des 
            Carpates et à l’animation des stations balnéaires. Nous organisons des excursions thématiques et des 
            circuits adaptés aux groupes d’adultes, aux familles ou aux élèves, en assurant un transport 
            confortable, un hébergement soigneusement sélectionné et un programme équilibré alliant culture, 
            histoire et détente.`,
        es: `Te proponemos viajes fascinantes por los destinos más bellos de Rumanía, desde el misterio de los 
            castillos de Transilvania y la tranquilidad de antiguos monasterios, hasta el esplendor natural de 
            los Montes Cárpatos y la animación de los complejos costeros. Organizamos excursiones temáticas y 
            circuitos adaptados a grupos de adultos, familias o estudiantes, garantizando transporte cómodo, 
            alojamiento cuidadosamente seleccionado y un programa equilibrado que combina cultura, historia y ocio.`,
        hu: `Izgalmas utazásokat kínálunk Románia legszebb úti céljain keresztül, az erdélyi várak misztikumától és 
            az ősi kolostorok nyugalmától a Kárpátok természeti szépségéig és a tengerparti üdülőhelyek pezsgéséig. 
            Tematikus kirándulásokat és körutakat szervezünk felnőttek, családok vagy diákok számára, kényelmes 
            közlekedéssel, gondosan kiválasztott szállással és kiegyensúlyozott programmal, amely a kultúrát, 
            a történelmet és a kikapcsolódást ötvözi.`
    },
    TRIPS_OUTSIDE: {
        ro: " Excursii în străinătate",
        en: "International trips",
        it: "Escursioni all’estero",
        de: "Auslandsreisen",
        fr: "Excursions à l’étranger",
        es: "Excursiones al extranjero",
        hu: "Külföldi kirándulások"
    },
    TRIPS_OUTSIDE_DESCRIPTION: {
        ro: `Descoperiți cu noi comorile Europei și ale lumii, prin excursii cu autocarul către orașe istorice,
            capitale culturale sau destinații pitorești. Fie că este vorba de o scurtă escapadă pentru adulți în
            Budapesta sau Viena, sau de un circuit educativ pentru elevi în Paris sau Roma, asigurăm o planificare
            impecabilă și ghiduri informați pentru o experiență autentică. Oferim o varietate de destinații pentru
            toate gusturile și bugetele.`,
        en: `Discover with us the treasures of Europe and the world through coach trips to historic cities, 
            cultural capitals, or picturesque destinations. Whether it’s a short getaway for adults to 
            Budapest or Vienna, or an educational tour for students in Paris or Rome, we ensure flawless 
            planning and knowledgeable guides for an authentic experience. We offer a wide range of 
            destinations for all tastes and budgets.`,
        it: `Scoprite con noi i tesori d’Europa e del mondo attraverso viaggi in pullman verso città storiche, 
            capitali culturali o destinazioni pittoresche. Che si tratti di una breve fuga per adulti a 
            Budapest o Vienna, o di un circuito educativo per studenti a Parigi o Roma, garantiamo una 
            pianificazione impeccabile e guide preparate per un’esperienza autentica. Offriamo una vasta 
            scelta di destinazioni per tutti i gusti e budget.`,
        de: `Entdecken Sie mit uns die Schätze Europas und der Welt bei Busreisen zu historischen Städten, 
            Kulturhauptstädten oder malerischen Reisezielen. Ob ein kurzer Städtetrip für Erwachsene nach 
            Budapest oder Wien oder eine Bildungsreise für Schüler nach Paris oder Rom – wir sorgen für eine 
            perfekte Planung und sachkundige Reiseleiter für ein authentisches Erlebnis. Wir bieten eine 
            Vielzahl von Reisezielen für jeden Geschmack und jedes Budget.`,
        fr: `Découvrez avec nous les trésors de l’Europe et du monde grâce à des excursions en autocar vers des 
            villes historiques, des capitales culturelles ou des destinations pittoresques. Qu’il s’agisse 
            d’une courte escapade pour adultes à Budapest ou Vienne, ou d’un circuit éducatif pour élèves à 
            Paris ou Rome, nous assurons une planification irréprochable et des guides compétents pour une 
            expérience authentique. Nous proposons une grande variété de destinations pour tous les goûts et 
            tous les budgets.`,
        es: `Descubre con nosotros los tesoros de Europa y del mundo mediante excursiones en autobús a ciudades 
            históricas, capitales culturales o destinos pintorescos. Ya sea una escapada corta para adultos 
            a Budapest o Viena, o un circuito educativo para estudiantes en París o Roma, garantizamos una 
            planificación impecable y guías expertos para una experiencia auténtica. Ofrecemos una amplia 
            variedad de destinos para todos los gustos y presupuestos.`,
        hu: `Fedezze fel velünk Európa és a világ kincseit autóbuszos kirándulások keretében történelmi városokba, 
            kulturális fővárosokba vagy festői úti célokra. Legyen szó egy rövid felnőtt kiruccanásról 
            Budapestre vagy Bécsbe, vagy egy oktatási körútról diákok számára Párizsba vagy Rómába, kifogástalan 
            szervezést és felkészült idegenvezetőket biztosítunk az autentikus élmény érdekében. Széles 
            úti célválasztékot kínálunk minden ízléshez és költségvetéshez.`
    },
    STUDENT_CAMPS: {
        ro: "Tabere pentru elevi",
        en: "Student camps",
        it: "Campi per studenti",
        de: "Schülercamps",
        fr: "Camps pour élèves",
        es: "Campamentos para estudiantes",
        hu: "Diáktáborok"
    },
    STUDENT_CAMPS_DESCRIPTION: {
        ro: `Pentru vacanțele școlare, organizăm tabere tematice și de recreere în stațiuni montane sau la mare,
            special concepute pentru copii și adolescenți. Acestea combină activități educative și de divertisment,
            explorarea mediului înconjurător și ateliere practice, într-un cadru supravegheat și sigur. Scopul
            nostru este de a oferi o experiență de grup formativă și distractivă, unde prieteniile și amintirile
            frumoase se nasc cu ușurință.`,
        en: `For school holidays, we organize themed and recreational camps in mountain resorts or by the sea, 
            specially designed for children and teenagers. These combine educational and entertainment 
            activities, exploration of the surrounding environment, and practical workshops in a safe and 
            supervised setting. Our goal is to offer a formative and fun group experience where friendships 
            and beautiful memories are easily created.`,
        it: `Durante le vacanze scolastiche organizziamo campi tematici e ricreativi in località montane o al mare, 
            appositamente pensati per bambini e adolescenti. Questi combinano attività educative e di svago, 
            l’esplorazione dell’ambiente circostante e laboratori pratici, in un contesto sicuro e sorvegliato. 
            Il nostro obiettivo è offrire un’esperienza di gruppo formativa e divertente, in cui nascono 
            facilmente amicizie e bellissimi ricordi.`,
        de: `Für die Schulferien organisieren wir thematische und Freizeitcamps in Berg- oder Küstenorten, die 
            speziell für Kinder und Jugendliche konzipiert sind. Diese verbinden Bildungs- und 
            Freizeitaktivitäten, die Erkundung der Umgebung und praktische Workshops in einem sicheren und 
            betreuten Umfeld. Unser Ziel ist es, ein lehrreiches und unterhaltsames Gruppenerlebnis zu bieten, 
            bei dem Freundschaften und schöne Erinnerungen entstehen.`,
        fr: `Pour les vacances scolaires, nous organisons des camps thématiques et de loisirs en montagne ou à la 
            mer, spécialement conçus pour les enfants et les adolescents. Ils combinent des activités 
            éducatives et ludiques, l’exploration de l’environnement et des ateliers pratiques, dans un cadre 
            sécurisé et encadré. Notre objectif est d’offrir une expérience de groupe à la fois formatrice et 
            amusante, où les amitiés et les beaux souvenirs se créent naturellement.`,
        es: `Para las vacaciones escolares, organizamos campamentos temáticos y recreativos en estaciones de 
            montaña o en la costa, especialmente diseñados para niños y adolescentes. Estos combinan 
            actividades educativas y de entretenimiento, exploración del entorno y talleres prácticos, en un 
            entorno seguro y supervisado. Nuestro objetivo es ofrecer una experiencia grupal formativa y 
            divertida, donde las amistades y los buenos recuerdos surgen con facilidad.`,
        hu: `Az iskolai szünetek idejére tematikus és szabadidős táborokat szervezünk hegyvidéki üdülőhelyeken vagy a 
            tengerparton, kifejezetten gyermekek és fiatalok számára. Ezek oktató és szórakoztató 
            tevékenységeket, környezetfelfedezést és gyakorlati műhelyeket ötvöznek, biztonságos és felügyelt 
            környezetben. Célunk egy olyan fejlesztő és szórakoztató csoportos élmény nyújtása, ahol a barátságok 
            és a szép emlékek könnyedén születnek.`
    }


} as const satisfies Record<string, TranslatableTextValue>;

export type TranslatableTextKey = keyof typeof TranslatableText;

export default TranslatableText;